import FormControl from "@material-ui/core/FormControl";
import ListSubheader from "@material-ui/core/ListSubheader";
import MenuItem from "@material-ui/core/MenuItem";
import ScopedCssBaseline from "@material-ui/core/ScopedCssBaseline";
import Select from "@material-ui/core/Select";
import {
  ThemeProvider,
  createTheme,
  makeStyles,
} from "@material-ui/core/styles";
import React from "react";
import { Flex, PanelIcon, Root } from "./styled";
import { getCurrencyCookie } from "shared/utils/cookies";
import { useTranslations } from "../../../../../shared/context/translations";
import { formatCurrency } from "../../../../../shared/formatters/currency";
import { filterVisible } from "../../helpers";
import { applyVat } from "../../../../../shared/utils/apply-vat";
import ShopifyPrice from "../../shopify-price";
import { canCheckoutOnline } from "../../../../../shared/constants/checkout";
import { getUrlVars } from "../../../../../shared/utils/url";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: `calc(100% - ${theme.spacing(2)}px)`,
    maxWidth: `calc(100% - ${theme.spacing(2)}px)`,
  },
}));

const theme = createTheme({
  palette: {
    primary: {
      light: "#ff3700",
      main: "#ff3700",
      dark: "#ff3700",
      contrastText: "#fff",
    },
  },
});

const relevancySort = (a, b) =>
  (Number.parseInt(b.relevancy, 10) || 0) - (Number.parseInt(a.relevancy, 10) || 0);

const PanelSelector = (props) => {
  const classes = useStyles();
  const {
    panelTypes,
    panel,
    panels,
    selectPanel,
    selectedPanel,
    isEmbedded,
  } = props;
  const t = useTranslations('configurator');
  const urlVars = getUrlVars();
  const showEmbeddedPrices = Object.hasOwn(urlVars, 'b2bFlag') || canCheckoutOnline();

  const renderPanelLabel = (panelData) => {
    if (!isEmbedded) {
      return `${panelData.name}${panelData.price ? ` - ${formatCurrency(
        applyVat(panelData.price || 0),
        getCurrencyCookie()
      )}` : ''}`;
    }

    if (!showEmbeddedPrices) {
      return panelData.name;
    }

    return (
      <span>
        {panelData.name}
        <span style={{ paddingLeft: '2px', paddingRight: '2px' }}>-</span>
        <ShopifyPrice
          shopifyVariantId={panelData.models?.[0]?.shopifyVariantId}
          fallbackPrice={panelData.price}
          loadingText="..."
        />
      </span>
    );
  };

  const handleChange = (event) => {
    if (!event.target.value) return;
    selectPanel(event.target.value);
  };

  return (
    <Root>
      <PanelIcon
        src={panel.icon?.src}
        alt={panel.icon?.title}
      />
      <Flex $alignEnd>
        <ScopedCssBaseline
          style={{ background: "transparent", width: "100%" }}
        >
          <ThemeProvider theme={theme}>
            <FormControl className={classes.formControl} size="small">
              <Select
                value={selectedPanel.type}
                variant="outlined"
                onChange={handleChange}
                displayEmpty
                renderValue={(v) => {
                  const selectedPanelData = panels.find((p) => p.id === v);
                  return v && selectedPanelData
                    ? renderPanelLabel(selectedPanelData)
                    : t('selectPanel');
                }}
                id="panel-selector"
              >
                {panelTypes.flatMap((pt) => ([
                    <ListSubheader key={pt.name}>{pt.name}</ListSubheader>,
                    ...filterVisible(panels)
                      .filter(({ type }) => type === pt.id)
                      .sort(relevancySort)
                      .map((panelData) => (
                        <MenuItem key={panelData.id} value={panelData.id}>
                          {renderPanelLabel(panelData)}
                        </MenuItem>
                      ))
                ]))}
              </Select>
            </FormControl>
          </ThemeProvider>
        </ScopedCssBaseline>
      </Flex>
    </Root>
  );
};

export default PanelSelector;
